
import { Component, Vue, Prop } from "vue-property-decorator";
import { Toast, Dialog } from "vant";
import { Service } from "src/decorator";
import { OrderService } from "src/services";
import dayjs from "dayjs";
import { Pay, tools } from "src/utils";

@Component
export default class OnlyBuy extends Vue
{
    /**
     * 先买后约订单状态映射
     * @private
     * @returns boolean
     */
    private OrderPendingStatusMap: any = {
        Cancel: 0,          // 已取消
        ToPay: 1,           // 待付款
        Pending: 2,         // 待预约
        Booked: 3,          // 已预约
        Refunded: 7,        // 已退款
        Completed: 4        // 已完成
    };

    /**
     * 先买后约订单状态映射
     * @private
     * @returns boolean
     */
    private OrderPendingStatusStrMap: any = {
        0: '已取消',
        1: '待付款',
        2: '待预约',
        3: '已预约',
        4: '已完成',
        7: '已退款',
    };

    /**
     * 体检订单状态映射
     * @private
     * @returns boolean
     */
     private PhysicalOrderStatusMap: any = {
        Cancel: 0,          // 已取消
        ToPay: 1,           // 待付款
        Booked: 2,          // 已预约(未超额)
        Payed: 3,           // 已预约(已超额)
        Completed: 4,       // 已完成
        ReportUpload: 5,    // 报告已上传
        Refunding: 6,       // 退款中
        Refunded: 7,        // 已退款
        Expired: 8,         // 已失效
        Booking: 77,        // 预约中
        Changing: 88,       // 改约中
        Canceling: 99       // 取消中
    };

    /**
     * 先买后约订单状态映射
     * @private
     * @returns boolean
     */
     private PhysicalOrderStatusStrMap: any = {
        0: '已取消',
        1: '待付款',
        2: '已预约',
        3: '已预约',
        4: '已完成',
        5: '报告已上传',
        6: '退款中',
        7: '已退款',
        8: '已失效',
        77: '预约中',
        88: '改约中',
        99: '取消中'
    };

    /**
     * 获取企业信息
     * @private
     * @returns any
     */
     private get orgInfo(): any
    {
        let orgInfoStorge = localStorage.getItem("orgInfo");
        if(orgInfoStorge)
        {
            return JSON.parse(orgInfoStorge)
        }
        return {};
    }

    /**
     * 温馨提示
     * @private
     * @returns 
     */
     private showOverlay: boolean = false;
    
    /**
     * 数据
     * @private
     * @returns string
     */
    @Prop({type: Object, default: ()=>({})})
    private item: any;

    /**
     * 是否显示日期
     * @private
     * @returns 
     */
     private showDate: boolean = false;

    /**
     * 显示日期弹框
     * @private
     * @returns void
     */
    private showDateModal(): void
    {
        this.showDate = true;
    }

    /**
     * 继续支付
     * @private
     * @param {params}
     * @returns {Promise<void>}
     */
    private async proceedPay(id): Promise<void>
    {
        this.$router.push({name: "pay", query:{orderNo: this.item.orderNo}});
        // try
        // {
        //     let {content: result} =  await OrderService.instance.proceedPay(id);

        //     if(result)
        //     {
                
        //         // Pay.onBridgeReady(result.data, this.getOrderList);
        //         this.$router.push({name: "pay", query:{orderNo: result.data.orderNo}});
                
        //     }
        // }
        // catch(err)
        // {
        //     Toast(err);
        // }
        
    }

    /**
     * 跳转详情
     * @private
     * @returns string
     */
    private onDetail(item): any
    {
        // 先买后约订单
        this.$router.push({name: "order-detail-unsubscribe", params:{ id: item.pendingOrderId }});
    }

    /**
     * 查看报告
     * @private
     * @returns string
     */
    private onShowReport(item): any
    {
        // // 未读跳转授权
        // if(!item.isRead) {
        //         this.$router.push({name: "reportLogin", query: {id: item.reportId + ""}});
        // } else {
        // // 已读跳详情
        //     this.$router.push({name: "reportAppointmentDetail", query: {id: item.reportId + ""}});
        // }

        if(!item.isAuth) {
            this.$router.push({name: "reportQuery", query: {id: item.reportId + ""}});
            // 本地存储数据
            let data = {
                    id: item.employerMemberId, 
                    name: item.memberName,
                    phone:item.memberPhone,
            }
            this.$store.dispatch("setReportParams",data)

        } else {
            this.$router.push({name: "reportAppointmentDetail", query: {id: item.reportId + ""}});
        }
    }

    /**
     * 确定改约
     * @private
     * @returns void
     */
     private onDateConfirm(date: string,physicalTimePeriod: string ): any
    {
        if(!date) return;

        let data = dayjs(date).format("YYYY-MM-DD");
            Dialog.confirm({
            title: "改约日期",
            message: `是否确定改约${data} ${physicalTimePeriod}体检`
        })
        .then(async() => {
            try
            {
                let {content: result} =  await OrderService.instance.modifiedOrderDate(this.item.id, data, physicalTimePeriod);

                this.$emit("refresh");

                Toast({
                    duration: 1000,
                    message: "改约成功"
                });
                
            }
            catch(err)
            {
                Toast(err);
            }
            finally
            {
                this.showDate = false;
            }
            
        });
    }

    /**
     * 继续支付
     * @private
     * @param {params}
     * @returns {Promise<void>}
     */
    private async getOrderList(id): Promise<void>
    {
       this.$emit("refresh");
        
    }

    /**
     * @description 跳转到评价页面
     * @private
     * @returns 
     */
    private evaluate(item:any):any{
        this.$router.push({name:"orderEvaluate", params:{id:item.id},query:{orderEvaluationId:item.orderEvaluationId}})
    }

    /**
     * 立即预约体检
     * @private
     * @returns void
     */
     private onGoSubscribe(): void
    {
        this.$router.push({ name:"order-submit-subscribe", query:{ orderId: this.item.pendingOrderId, orderKind: this.item.orderKind }})
    }

    /**
     * 取消先买后约订单
     * @private
     * @param {params}
     * @returns {Promise<void>}
     */
     private onCancelPendingOrder(): void
    {
        Dialog.confirm({
            title: "取消订单",
            message: "是否确定取消订单? 取消后需要重新购买"
        })
        .then(async() => {
            try
            {
                let  result: any =  await OrderService.instance.pendingCancel(this.item.pendingOrderId);
                if(result.code == 1000)
                {
                    this.showOverlay = true;
                }
                else
                {
                    Toast.success("取消成功!");
                    this.$emit("refresh");
                }
            }
            catch(err)
            {
                Toast(err);
            }
        });
    }

    /**
     * 申请退款
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
     public async onRequestRefund(): Promise<void>
    {
        Dialog.confirm({
            title: "申请退款",
            message: "是否确定申请退款？"
        })
        .then(async() => {
            try
            {
                let  result: any =  await OrderService.instance.pendingCancel(this.item.pendingOrderId);
                if(result.code == 1000)
                {
                    this.showOverlay = true;
                }
                else
                {
                    Toast.success("退款成功!");
                    this.$emit("refresh");
                }
            }
            catch(err)
            {
                Toast(err);
            }
        });
    }
}
